import { useTheme } from '@mui/material';

import deepTechnicalExpertiseIcon from '../../../public/svg/icons/xrplWhyRF/deepTechnicalExpertise.svg';
import endToEndCapabilitiesIcon from '../../../public/svg/icons/xrplWhyRF/endToEndCapabilities.svg';
import productionProvenIcon from '../../../public/svg/icons/xrplWhyRF/productionProven.svg';
import regulatoryAwarenessIcon from '../../../public/svg/icons/xrplWhyRF/regulatoryAwereness.svg';

export const WhyRFData = () => {
  const theme = useTheme();
  return [
    {
      name: 'deep_technical_expertise',
      icon: deepTechnicalExpertiseIcon,
      title: 'Deep Technical Expertise',
      boxShadow: theme.mixins.orangeGradientTransparent?.boxShadow || '',
      duration: 4,
      floatingY: 7.4,
      description:
        "We don't just read the docs - we've contributed to them. Our team has years of experience building production systems on various blockchains.",
    },
    {
      name: 'end_to_end_capabilities',
      icon: endToEndCapabilitiesIcon,
      title: 'End-to-End Capabilities',
      boxShadow: theme.mixins.redGradientTransparent?.boxShadow || '',
      duration: 5,
      floatingY: 3,
      description:
        'From smart contracts to frontend interfaces to backend infrastructure, we handle the full stack. One team that works like a well-oiled machine.',
    },
    {
      name: 'regulatory_awareness',
      icon: regulatoryAwarenessIcon,
      title: 'Regulatory Awareness',
      boxShadow: theme.mixins.magentaGradientTransparent?.boxShadow || '',
      duration: 2,
      floatingY: 4.5,
      description:
        'The XRPL provides native tools for authorization, compliance, and asset control. We know how to use them to keep you compliant.',
    },
    {
      name: 'production_proven',
      icon: productionProvenIcon,
      title: 'Production-Proven',
      boxShadow: theme.mixins.blueGradientTransparent?.boxShadow || '',
      duration: 3,
      floatingY: 4.5,
      description:
        'We build systems that work under pressure. When there\'s real money involved, "mostly working" isn\'t good enough.',
    },
  ];
};
